import React, { useState, useEffect } from 'react';
import usePadsStore from '../../stores/usePadsStore';
import styles from './ToolCard.module.css';

const PadsToolCard = () => {
  const padsState = usePadsStore((state) => state.pads);
  const setPads = usePadsStore((state) => state.setPads);
  
  // Use local state for UI but sync with store
  const [padsSettings, setPadsSettings] = useState(padsState);

  // Sync with store when component mounts or store changes
  useEffect(() => {
    setPadsSettings(padsState);
  }, [padsState]);

  const selectedSize = padsSettings.selectedSize || 'big';

  const handleSizeChange = (size) => {
    setPadsSettings(prev => ({ ...prev, selectedSize: size }));
    setPads({ selectedSize: size });
  };

  const sizeOptions = [
    { id: 'big', label: 'Big (80mm)', value: 80 },
    { id: 'medium', label: 'Medium (60mm)', value: 60 },
    { id: 'small', label: 'Small (40mm)', value: 40 }
  ];

  return (
    <div className={styles.toolCard}>
      <div className={styles.toolCardHeader}>
        <h3>Select Padding</h3>
      </div>
      
      <div style={{ 
        border: '2px solid #7c3aed', 
        borderRadius: 8, 
        padding: 16, 
        background: 'white',
        marginBottom: 16
      }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {sizeOptions.map((option) => (
            <div key={option.id} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <input
                type="radio"
                id={option.id}
                name="pads"
                checked={selectedSize === option.id}
                onChange={() => handleSizeChange(option.id)}
                style={{
                  width: 16,
                  height: 16,
                  accentColor: '#7c3aed'
                }}
              />
              <label 
                htmlFor={option.id} 
                style={{ 
                  fontSize: 14, 
                  fontWeight: 500, 
                  color: '#374151',
                  cursor: 'pointer'
                }}
              >
                {option.label}
              </label>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PadsToolCard; 